// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__exulO","content":"Settings_content__d-2l2"};